
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35153',
  depVersions: {
  "documents-public-ui": "static-1.35153",
  "atom": "static-1.5348",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2757",
  "client-types": "static-1.494",
  "cssUtils": "static-1.881",
  "customer-data-filters-ui": "static-1.40802",
  "customer-data-objects": "static-1.7950",
  "customer-data-property-utils": "static-1.8362",
  "documents-lib": "static-1.35158",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.362",
  "FormsCommonComponents": "static-1.86494",
  "FormUrlGenerator": "static-2.4990",
  "foundations-theming-specialty": "static-1.2446",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5858",
  "hs-test-utils": "static-1.8292",
  "hub-http": "static-1.6476",
  "hubspot-dlb": "static-2.1882",
  "HubStyle": "static-2.12054",
  "HubStyleTokens": "static-2.11747",
  "I18n": "static-7.1665",
  "icons": "static-2.675",
  "jasmine-immutable": "static-1.3286",
  "jasmine-runner": "static-1.6715",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7414",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3159",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5660",
  "quartz": "static-1.7399",
  "react": "static-7.191",
  "react-dlb": "static-1.87",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-feat-wv-soft-nav-lcp.6",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5529",
  "react-virtualized": "static-2.104",
  "reference-resolvers": "static-1.8443",
  "reference-resolvers-lite": "static-1.8364",
  "reporting-data": "static-1.68663",
  "reporting-reports": "static-1.68340",
  "reporting-snowflake": "static-1.57280",
  "reporting-testing-lib": "static-1.10596",
  "reporting-visualizations": "static-1.60738",
  "reselect": "static-3.9",
  "sales-content-partitioning": "static-1.9213",
  "sanitize": "static-1.4738",
  "sanitize-text": "static-1.8415",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.2011",
  "signup-constants": "static-1.19541",
  "signup-ui-url-generator": "static-2.8323",
  "StyleGuideUI": "static-3.497",
  "superstore": "static-1.5020",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.5019",
  "ui-addon-form-validation": "static-1.11248",
  "ui-asset-management-lib": "static-1.11359",
  "ui-images": "static-2.1234",
  "UIComponents": "static-3.8693",
  "usage-tracker": "static-1.7619",
  "usage-tracker-container": "static-1.7609",
  "usage-tracker-core": "static-1.7469",
  "viral-links-lib": "static-1.7337",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9921",
  "foundations-components": "static-1.8423",
  "immutable": "static-2.83",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1177",
  "quartz-core": "static-1.6618",
  "quick-fetch": "static-1.4106",
  "raven": "static-3.5925",
  "redux": "static-4.76",
  "redux-thunk": "static-2.77",
  "rpc-client-utils": "static-1.4926",
  "ui-addon-i18n": "static-1.11407",
  "ui-addon-upgrades": "static-9.18335",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4297",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3592",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3676",
  "quartz-webpack": "static-1.3623",
  "foundations-assets": "static-1.5146",
  "foundations-theming": "static-1.4730",
  "hub-http-janus": "static-1.871",
  "hub-http-shared-msw-handlers": "static-1.10554",
  "hubspotter-http": "static-1.4838",
  "sassPrefix": "static-1.163",
  "conversations-skeleton-state": "static-1.7512",
  "crm-message-bus": "static-1.43676",
  "customer-data-filters-ui-msw-helpers": "static-1.23237",
  "customer-data-objects-ui-components": "static-1.13291",
  "customer-data-reference-ui-components": "static-1.13442",
  "customer-data-ui-utilities": "static-1.10091",
  "events-data-lib": "static-1.504",
  "framework-builder-read-service-client": "static-1.4197",
  "hs-resources": "static-1.454",
  "immer": "static-1.94",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4032",
  "multi-account-reference-resolvers": "static-1.1261",
  "onboarding-scopes": "static-1.6717",
  "onboarding-tours": "static-1.17064",
  "pulse": "static-1.889",
  "reporting-datasets-permissions-lib": "static-1.14397",
  "stylex": "static-1.38",
  "trellis-assets": "static-1.2530",
  "trellis-components": "static-1.2549",
  "trellis-theming": "static-1.1229",
  "ui-addon-teams": "static-1.21871",
  "quartz-auth": "static-1.1074",
  "ui-business-units-lib": "static-1.9346",
  "usage-tracker-session-replay": "static-1.5305",
  "ai-components-ui-library": "static-1.9632",
  "ContentUtils": "static-1.69063",
  "customer-data-properties": "static-1.52477",
  "forms-ai-lib": "static-1.4714",
  "forms-utils-lib": "static-1.13042",
  "foundations-components-test-utils": "static-1.5906",
  "react-dnd-compat": "static-1.4878",
  "react-tinymce": "static-1.55907",
  "tinymce-config": "static-2.55033",
  "ui-gdpr-components": "static-1.10619",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3715",
  "HeadJS": "static-2.791",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3403",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.268",
  "ui-fonts": "static-1.1009",
  "i18n-data": "static-1.228",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4578",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1064",
  "web-vitals": "static-1.11",
  "batch-promise": "static-1.1805",
  "external-options-client-types": "static-1.4315",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7156",
  "quartz-i18n": "static-1.1074",
  "frontend-preferences-client": "static-1.8188",
  "graphql": "static-1.86",
  "persist-promise": "static-1.3962",
  "reporting-client-types": "static-1.2656",
  "apollo-stack-hubspot": "static-3.90",
  "growth-payments-core": "static-1.26107",
  "hubspot-apollo-client": "static-1.5141",
  "foundations-components-legacy": "static-1.1448",
  "quartz-routing": "static-1.829",
  "hs-story-utils": "static-1.9689",
  "react-flip-move": "static-1.75",
  "nested-table": "static-1.498",
  "seat-types-lib": "static-1.658",
  "timezone-utils": "static-2.5509",
  "react-create-root-preference": "static-1.64",
  "bend-plugin-foundations-components": "static-1.4692",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "tanstack-table": "static-1.59",
  "opentelemetry-fe-types": "static-1.32",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.571",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.407",
  "quartz-test": "static-1.1074",
  "quartz-tracking": "static-1.778",
  "bend-plugin-chirp-manifest": "static-1.336",
  "chirp-fetch": "static-1.2157",
  "merchandise-lib": "static-1.275",
  "purchase-motions-components": "static-1.6301",
  "salesImages": "static-1.532",
  "ts-schema": "static-1.4269",
  "bender-build-tools": "static-1.3401",
  "bend-plugin-foundations-theming": "static-1.3213",
  "restore-request-side-panel-lib": "static-1.1596",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4919",
  "conditional-properties-service-client": "static-1.3987",
  "crm-pipelines-api-client-types": "static-1.4323",
  "event-emitter": "static-1.1217",
  "fdsr-migration-layer": "static-1.275",
  "multi-currency-client-types": "static-1.3884",
  "getting-started-shared-tasks": "static-1.19153",
  "growth-data-modal": "static-1.5842",
  "growth-onboarding-confetti": "static-1.3326",
  "growth-onboarding-next-action-utils": "static-1.2626",
  "navigation-components": "static-1.18742",
  "onboarding-tours-client": "static-1.5278",
  "onboarding-tours-utils": "static-1.1130",
  "ui-shepherd-react": "static-3.10529",
  "ui-shepherd-tracker": "static-1.7910",
  "ui-universal-auth": "static-1.9327",
  "user-context": "static-1.5381",
  "bend-plugin-pulse": "static-1.392",
  "fast-json-patch": "static-1.67",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "hubspotter-http-shared-msw-handlers": "static-1.10552",
  "magpie-lib": "static-1.5728",
  "navigation-messaging": "static-1.8069",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.22737",
  "copilot-toolkit": "static-1.11778",
  "cms-field-types": "static-1.5077",
  "content-icons-ui": "static-1.2326",
  "integrations-lib": "static-1.16961",
  "calling-global-api": "static-1.65447",
  "calling-internal-common": "static-1.31581",
  "calling-lifecycle-internal": "static-1.66829",
  "calling-lifecycle-messages": "static-1.59123",
  "commerce-products-lib": "static-1.10450",
  "crm-index-visualization-core": "static-1.4494",
  "crm-links": "static-1.6591",
  "customer-data-properties-shared-msw-handlers": "static-1.9881",
  "file-manager-components": "static-1.24401",
  "formula-editor": "static-1.14695",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4400",
  "meetings-icalendar-utils-lib": "static-1.899",
  "object-builder-ui-client": "static-1.49581",
  "pipeline-validation-client-types": "static-1.4157",
  "property-value-citations": "static-1.3091",
  "smart-data-capture-core": "static-1.59",
  "smart-property-lib": "static-1.8210",
  "tiered-pricing": "static-1.1897",
  "topics-actions-lib": "static-1.428",
  "trial-components-library": "static-1.14048",
  "ui-addon-iframeable": "static-1.9336",
  "zustand": "static-1.79",
  "final-form": "static-1.75",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.75",
  "rich-text-lib": "static-1.20255",
  "tinymce-themes": "static-1.57003",
  "data-token-picker": "static-1.16836",
  "hub-http-contrib": "static-1.3301",
  "interframe": "static-3.5018",
  "tinymce-data": "static-1.41118",
  "tinymce-plugins": "static-1.58147",
  "ui-addon-sales-email": "static-1.5477",
  "framework-data-schema-quick-fetch": "static-1.7061",
  "ui-addon-opt": "static-4.8629",
  "hubspot-apollo-cache": "static-1.600",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.426",
  "opentelemetry-web": "static-1.11",
  "purchase-motions-api": "static-1.6304",
  "onboarding-data-sync-lib": "static-1.2441",
  "growth-onboarding-next-action-components": "static-1.2654",
  "user-context-client": "static-1.4772",
  "idb-keyval": "static-1.48",
  "magpie-types": "static-1.5188",
  "nest": "static-1.499",
  "reactive-lib": "static-1.983",
  "simple-logging-lib": "static-1.3313",
  "unified-auth-core-lib": "static-1.1123",
  "getting-started-shared-tasks-store": "static-1.18271",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1614",
  "integrations-error-boundary-lib": "static-1.14376",
  "integrations-tracking-lib": "static-1.5870",
  "native-integrations-shared-strings": "static-1.8041",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10632",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.841",
  "calling-error-reporting": "static-1.31588",
  "shared-worker-versioning": "static-1.11303",
  "calling-usage-tracker": "static-1.6800",
  "voice-sms-access-library": "static-1.1949",
  "customer-data-tracking": "static-1.7143",
  "commerce-permissions": "static-1.1039",
  "products-iframe-lib": "static-1.8524",
  "products-ui-components-shared-msw-handlers": "static-1.10936",
  "crm-index-associations-lib": "static-1.6705",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10637",
  "sales-views-client-types": "static-1.4519",
  "location-customization-utils-lib": "static-1.10024",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4414",
  "video-components-external": "static-1.12088",
  "video-data-lib": "static-1.35746",
  "bark-lib": "static-1.16771",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6152",
  "react-codemirror": "static-1.10901",
  "data-agent-kit": "static-1.594",
  "feedback-loader": "static-1.29757",
  "fsm": "static-1.4005",
  "policy-lib": "static-1.7061",
  "react-colorpicker": "static-2.10471",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10700",
  "embedded-academy-lib": "static-1.15414",
  "hubs-service-types": "static-1.1521",
  "FileManagerLib": "static-1.40041",
  "NamespacedHubStyle": "static-2.9237",
  "FileManagerCore": "static-1.39900",
  "content-assistance-lib": "static-1.8151",
  "layout-dnd-components": "static-1.12911",
  "layout-dnd-utils": "static-1.11886",
  "ui-addon-emoji-picker": "static-1.10148",
  "ui-brand-identity-lib": "static-1.16313",
  "InboxConnectUtils": "static-4.15486",
  "meetings-connect-utils-lib": "static-1.7872",
  "breeze-engine-chat-components": "static-1.592",
  "breeze-engine-core": "static-1.892",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "universal-page-editor-lib": "static-1.3270",
  "adobe-sign-auth-lib": "static-1.386",
  "ads-unified-auth-lib": "static-1.1161",
  "google-sheets-integration-lib": "static-1.961",
  "microsoft-drive-auth-lib": "static-1.59",
  "surveymonkey-integration-lib": "static-1.403",
  "slack-ui-library": "static-1.10661",
  "calling-orchestration-schema": "static-1.36726",
  "crm-record-cards-service-types": "static-1.3759",
  "content-media-composition-data-lib": "static-1.13159",
  "content-media-compositions": "static-2.17166",
  "media-bridge-lib": "static-1.19356",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16296",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4773",
  "storybook-react": "static-1.37",
  "academy-common-lib": "static-1.14874",
  "audio-components": "static-1.6291",
  "FileManagerImages": "static-1.37552",
  "video-components": "static-1.14090",
  "breeze-artifacts-sdk": "static-1.229",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4796",
  "video-embed": "static-1.36580",
  "ui-addon-video-player": "static-1.8965",
  "ui-coaching-tips": "static-1.29245",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10211",
  "academy-service-client": "static-1.3952",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4668",
  "trellis-ecosystem": "static-1.7581",
  "ui-addon-react-router-dom": "static-1.9801",
  "wootric-nps": "static-1.7175",
  "social-insights-client-types": "static-1.22685",
  "outpost": "static-1.4422",
  "growth-onboarding-feedback-components": "static-1.6846",
  "advanced-menus-core": "static-1.15528",
  "advanced-menus-lib": "static-1.12407",
  "ExportDialog": "static-6.10641",
  "ui-memberships-settings-lib": "static-1.34773",
  "marketplace-ui-apps-core": "static-1.19170",
  "marketplace-ui-common": "static-1.20638",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15527",
  "simple-menus-lib": "static-1.17044",
  "developer-experience-shared-components": "static-1.10766",
  "immutable-less": "static-1.4913",
  "marketplace-ui-client-types": "static-1.18045",
  "ui-addon-integrations-directory-panel": "static-2.8288",
  "ui-extensibility-client-types": "static-1.4183",
  "ai-settings-ui-library": "static-1.8274",
  "nav-meta": "static-1.30379",
  "ui-product-approvals-common": "static-1.923",
  "apps-service-types": "static-1.4003",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3466"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35153",
  "atom": "/atom/static-1.5348",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2757",
  "client-types": "/client-types/static-1.494",
  "cssUtils": "/cssUtils/static-1.881",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40802",
  "customer-data-objects": "/customer-data-objects/static-1.7950",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8362",
  "documents-lib": "/documents-lib/static-1.35158",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.362",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86494",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4990",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2446",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5858",
  "hs-test-utils": "/hs-test-utils/static-1.8292",
  "hub-http": "/hub-http/static-1.6476",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyle": "/HubStyle/static-2.12054",
  "HubStyleTokens": "/HubStyleTokens/static-2.11747",
  "I18n": "/I18n/static-7.1665",
  "icons": "/icons/static-2.675",
  "jasmine-immutable": "/jasmine-immutable/static-1.3286",
  "jasmine-runner": "/jasmine-runner/static-1.6715",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7414",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3159",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5660",
  "quartz": "/quartz/static-1.7399",
  "react": "/react/static-7.191",
  "react-dlb": "/react-dlb/static-1.87",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-feat-wv-soft-nav-lcp.6",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5529",
  "react-virtualized": "/react-virtualized/static-2.104",
  "reference-resolvers": "/reference-resolvers/static-1.8443",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8364",
  "reporting-data": "/reporting-data/static-1.68663",
  "reporting-reports": "/reporting-reports/static-1.68340",
  "reporting-snowflake": "/reporting-snowflake/static-1.57280",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10596",
  "reporting-visualizations": "/reporting-visualizations/static-1.60738",
  "reselect": "/reselect/static-3.9",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9213",
  "sanitize": "/sanitize/static-1.4738",
  "sanitize-text": "/sanitize-text/static-1.8415",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2011",
  "signup-constants": "/signup-constants/static-1.19541",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8323",
  "StyleGuideUI": "/StyleGuideUI/static-3.497",
  "superstore": "/superstore/static-1.5020",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5019",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11248",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11359",
  "ui-images": "/ui-images/static-2.1234",
  "UIComponents": "/UIComponents/static-3.8693",
  "usage-tracker": "/usage-tracker/static-1.7619",
  "usage-tracker-container": "/usage-tracker-container/static-1.7609",
  "usage-tracker-core": "/usage-tracker-core/static-1.7469",
  "viral-links-lib": "/viral-links-lib/static-1.7337",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9921",
  "foundations-components": "/foundations-components/static-1.8423",
  "immutable": "/immutable/static-2.83",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1177",
  "quartz-core": "/quartz-core/static-1.6618",
  "quick-fetch": "/quick-fetch/static-1.4106",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.76",
  "redux-thunk": "/redux-thunk/static-2.77",
  "rpc-client-utils": "/rpc-client-utils/static-1.4926",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11407",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18335",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3592",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3676",
  "quartz-webpack": "/quartz-webpack/static-1.3623",
  "foundations-assets": "/foundations-assets/static-1.5146",
  "foundations-theming": "/foundations-theming/static-1.4730",
  "hub-http-janus": "/hub-http-janus/static-1.871",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10554",
  "hubspotter-http": "/hubspotter-http/static-1.4838",
  "sassPrefix": "/sassPrefix/static-1.163",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7512",
  "crm-message-bus": "/crm-message-bus/static-1.43676",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23237",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13291",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13442",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10091",
  "events-data-lib": "/events-data-lib/static-1.504",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4197",
  "hs-resources": "/hs-resources/static-1.454",
  "immer": "/immer/static-1.94",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4032",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1261",
  "onboarding-scopes": "/onboarding-scopes/static-1.6717",
  "onboarding-tours": "/onboarding-tours/static-1.17064",
  "pulse": "/pulse/static-1.889",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14397",
  "stylex": "/stylex/static-1.38",
  "trellis-assets": "/trellis-assets/static-1.2530",
  "trellis-components": "/trellis-components/static-1.2549",
  "trellis-theming": "/trellis-theming/static-1.1229",
  "ui-addon-teams": "/ui-addon-teams/static-1.21871",
  "quartz-auth": "/quartz-auth/static-1.1074",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9346",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5305",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9632",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "customer-data-properties": "/customer-data-properties/static-1.52477",
  "forms-ai-lib": "/forms-ai-lib/static-1.4714",
  "forms-utils-lib": "/forms-utils-lib/static-1.13042",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5906",
  "react-dnd-compat": "/react-dnd-compat/static-1.4878",
  "react-tinymce": "/react-tinymce/static-1.55907",
  "tinymce-config": "/tinymce-config/static-2.55033",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10619",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3715",
  "HeadJS": "/HeadJS/static-2.791",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3403",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.268",
  "ui-fonts": "/ui-fonts/static-1.1009",
  "i18n-data": "/i18n-data/static-1.228",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4578",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1064",
  "web-vitals": "/web-vitals/static-1.11",
  "batch-promise": "/batch-promise/static-1.1805",
  "external-options-client-types": "/external-options-client-types/static-1.4315",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7156",
  "quartz-i18n": "/quartz-i18n/static-1.1074",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8188",
  "graphql": "/graphql/static-1.86",
  "persist-promise": "/persist-promise/static-1.3962",
  "reporting-client-types": "/reporting-client-types/static-1.2656",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "growth-payments-core": "/growth-payments-core/static-1.26107",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5141",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1448",
  "quartz-routing": "/quartz-routing/static-1.829",
  "hs-story-utils": "/hs-story-utils/static-1.9689",
  "react-flip-move": "/react-flip-move/static-1.75",
  "nested-table": "/nested-table/static-1.498",
  "seat-types-lib": "/seat-types-lib/static-1.658",
  "timezone-utils": "/timezone-utils/static-2.5509",
  "react-create-root-preference": "/react-create-root-preference/static-1.64",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4692",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "tanstack-table": "/tanstack-table/static-1.59",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.32",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.571",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.407",
  "quartz-test": "/quartz-test/static-1.1074",
  "quartz-tracking": "/quartz-tracking/static-1.778",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.336",
  "chirp-fetch": "/chirp-fetch/static-1.2157",
  "merchandise-lib": "/merchandise-lib/static-1.275",
  "purchase-motions-components": "/purchase-motions-components/static-1.6301",
  "salesImages": "/salesImages/static-1.532",
  "ts-schema": "/ts-schema/static-1.4269",
  "bender-build-tools": "/bender-build-tools/static-1.3401",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3213",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1596",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4919",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3987",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4323",
  "event-emitter": "/event-emitter/static-1.1217",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.275",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3884",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19153",
  "growth-data-modal": "/growth-data-modal/static-1.5842",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3326",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2626",
  "navigation-components": "/navigation-components/static-1.18742",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5278",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1130",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10529",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7910",
  "ui-universal-auth": "/ui-universal-auth/static-1.9327",
  "user-context": "/user-context/static-1.5381",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.392",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10552",
  "magpie-lib": "/magpie-lib/static-1.5728",
  "navigation-messaging": "/navigation-messaging/static-1.8069",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.22737",
  "copilot-toolkit": "/copilot-toolkit/static-1.11778",
  "cms-field-types": "/cms-field-types/static-1.5077",
  "content-icons-ui": "/content-icons-ui/static-1.2326",
  "integrations-lib": "/integrations-lib/static-1.16961",
  "calling-global-api": "/calling-global-api/static-1.65447",
  "calling-internal-common": "/calling-internal-common/static-1.31581",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66829",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59123",
  "commerce-products-lib": "/commerce-products-lib/static-1.10450",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4494",
  "crm-links": "/crm-links/static-1.6591",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9881",
  "file-manager-components": "/file-manager-components/static-1.24401",
  "formula-editor": "/formula-editor/static-1.14695",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4400",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.899",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49581",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4157",
  "property-value-citations": "/property-value-citations/static-1.3091",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.59",
  "smart-property-lib": "/smart-property-lib/static-1.8210",
  "tiered-pricing": "/tiered-pricing/static-1.1897",
  "topics-actions-lib": "/topics-actions-lib/static-1.428",
  "trial-components-library": "/trial-components-library/static-1.14048",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9336",
  "zustand": "/zustand/static-1.79",
  "final-form": "/final-form/static-1.75",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "rich-text-lib": "/rich-text-lib/static-1.20255",
  "tinymce-themes": "/tinymce-themes/static-1.57003",
  "data-token-picker": "/data-token-picker/static-1.16836",
  "hub-http-contrib": "/hub-http-contrib/static-1.3301",
  "interframe": "/interframe/static-3.5018",
  "tinymce-data": "/tinymce-data/static-1.41118",
  "tinymce-plugins": "/tinymce-plugins/static-1.58147",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5477",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7061",
  "ui-addon-opt": "/ui-addon-opt/static-4.8629",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.600",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "purchase-motions-api": "/purchase-motions-api/static-1.6304",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2441",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2654",
  "user-context-client": "/user-context-client/static-1.4772",
  "idb-keyval": "/idb-keyval/static-1.48",
  "magpie-types": "/magpie-types/static-1.5188",
  "nest": "/nest/static-1.499",
  "reactive-lib": "/reactive-lib/static-1.983",
  "simple-logging-lib": "/simple-logging-lib/static-1.3313",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1123",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18271",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1614",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14376",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5870",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8041",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10632",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.841",
  "calling-error-reporting": "/calling-error-reporting/static-1.31588",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11303",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6800",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1949",
  "customer-data-tracking": "/customer-data-tracking/static-1.7143",
  "commerce-permissions": "/commerce-permissions/static-1.1039",
  "products-iframe-lib": "/products-iframe-lib/static-1.8524",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10936",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6705",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10637",
  "sales-views-client-types": "/sales-views-client-types/static-1.4519",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10024",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4414",
  "video-components-external": "/video-components-external/static-1.12088",
  "video-data-lib": "/video-data-lib/static-1.35746",
  "bark-lib": "/bark-lib/static-1.16771",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6152",
  "react-codemirror": "/react-codemirror/static-1.10901",
  "data-agent-kit": "/data-agent-kit/static-1.594",
  "feedback-loader": "/feedback-loader/static-1.29757",
  "fsm": "/fsm/static-1.4005",
  "policy-lib": "/policy-lib/static-1.7061",
  "react-colorpicker": "/react-colorpicker/static-2.10471",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10700",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15414",
  "hubs-service-types": "/hubs-service-types/static-1.1521",
  "FileManagerLib": "/FileManagerLib/static-1.40041",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9237",
  "FileManagerCore": "/FileManagerCore/static-1.39900",
  "content-assistance-lib": "/content-assistance-lib/static-1.8151",
  "layout-dnd-components": "/layout-dnd-components/static-1.12911",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11886",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10148",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16313",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15486",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7872",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.592",
  "breeze-engine-core": "/breeze-engine-core/static-1.892",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3270",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.386",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1161",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.961",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.59",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.403",
  "slack-ui-library": "/slack-ui-library/static-1.10661",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36726",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13159",
  "content-media-compositions": "/content-media-compositions/static-2.17166",
  "media-bridge-lib": "/media-bridge-lib/static-1.19356",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16296",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4773",
  "storybook-react": "/storybook-react/static-1.37",
  "academy-common-lib": "/academy-common-lib/static-1.14874",
  "audio-components": "/audio-components/static-1.6291",
  "FileManagerImages": "/FileManagerImages/static-1.37552",
  "video-components": "/video-components/static-1.14090",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.229",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4796",
  "video-embed": "/video-embed/static-1.36580",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8965",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29245",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10211",
  "academy-service-client": "/academy-service-client/static-1.3952",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4668",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7581",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9801",
  "wootric-nps": "/wootric-nps/static-1.7175",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "outpost": "/outpost/static-1.4422",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6846",
  "advanced-menus-core": "/advanced-menus-core/static-1.15528",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12407",
  "ExportDialog": "/ExportDialog/static-6.10641",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34773",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19170",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20638",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15527",
  "simple-menus-lib": "/simple-menus-lib/static-1.17044",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10766",
  "immutable-less": "/immutable-less/static-1.4913",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18045",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8288",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4183",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8274",
  "nav-meta": "/nav-meta/static-1.30379",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.923",
  "apps-service-types": "/apps-service-types/static-1.4003",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3466"
}
};
